import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Form, FormElement } from "@progress/kendo-react-form";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import {
  SimpleLoading,
  PromotionalFooterPure,
  InputsFormPure,
  DescriptionTemplatePure,
  TitleTemplatePure,
  ComboBoxTemplatePure,
  CheckBoxTemplatePure,
  NotificationDialogsPure,
} from "../../pures";
import "./tax-data-invoicing.css";

const TaxDataInvoicingView = (props) => {
  const { t } = useTranslation();
  const longmatches = useMediaQuery("(max-width:1200px)");

  const globalContainerStyles = {
    display: "inline-block",
    justifyContent: "flex-start",
    maxWidth: "100%",
    backgroundColor: "white",
    boxShadow: "1px 1px 3px #959595",
    width: "auto",
  };

  if (longmatches) {
    globalContainerStyles.marginRight = 0;
  }

  return (
    <div className="panelStyle-taxDataInvoincing">
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <Container
          spacing={4}
          sm={12}
          xs={12}
          lg={12}
          md={12}
          style={globalContainerStyles}
        >
          <Container es={12} className="table-card-taxDataInvoincing">
            <Grid item className="taxDataInvoicing-title">
              <TitleTemplatePure title={props.title} />
            </Grid>
            <Grid
              container
              className="taxDataInvoincing-container"
              xs={12}
              lg={12}
              md={12}
              sm={12}
              es={12}
            >
              <Grid
                item
                xs={12}
                lg={12}
                md={12}
                sm={12}
                es={12}
                className="container-cards-taxDataInvoincing"
              >
                <Form
                  onSubmit={props.onSubmitUpdateUserTaxData}
                  render={() => (
                    <FormElement>
                      <div className="container-tax-data">
                        <DescriptionTemplatePure
                          description={props.description}
                        />
                        <Container spacing={2} lg={12} md={12} sm={6} xs={12}>
                          <fieldset className={"k-form-fieldset fieldset"}>
                            <Grid
                              container
                              className="container-inputs"
                              lg={12}
                              md={12}
                            >
                              <div className="combo-name">
                                <ComboBoxTemplatePure
                                  title={t(
                                    "taxDataInvoicingView.nameBusinessNameRFC"
                                  )}
                                  data={props.taxData}
                                  onChange={props.onChangeComboBox}
                                  textField="business"
                                  dataItemKey="id"
                                  placeholder={
                                    props.taxData.length !== 0
                                      ? t(
                                        "taxDataInvoicingView.registerOrSelect"
                                      )
                                      : "Registra nuevos datos fiscales"
                                  }
                                // listNoDataRender={listNoDataRender}
                                />
                              </div>
                              <Grid
                                item
                                lg={6}
                                md={6}
                                sm={12}
                                xs={12}
                                className="align-items"
                              >
                                <div className="input-style-taxData">
                                  <InputsFormPure
                                    type="text"
                                    name="organization"
                                    minLength={2}
                                    title={
                                      t("taxDataInvoicingView.nameSocial") +
                                      " *"
                                    }
                                    value={props.organization || ""}
                                    onChange={props.onChange}
                                    validator={
                                      props.validator.organizationValidator
                                    }
                                  />
                                  {props.errorOrganization && (
                                    <span className="hint-message-error">
                                      {t(
                                        "taxDataInvoincingValidator.errorOrganization"
                                      )}
                                    </span>
                                  )}
                                </div>
                                <div className="input-style-taxData">
                                  <InputsFormPure
                                    type="text"
                                    name="rfc"
                                    minLength={2}
                                    title={
                                      t("taxDataInvoaInvoicingView.rfc") + " *"
                                    }
                                    value={props.rfc || ""}
                                    onChange={props.onChange}
                                    validator={props.validator.rfcValidator}
                                  />
                                  {props.errorRfc && (
                                    <span className="hint-message-error">
                                      {t("taxDataInvoincingValidator.errorRFC")}
                                    </span>
                                  )}
                                </div>
                                <div className="input-style-taxData">
                                  <InputsFormPure
                                    type="text"
                                    name="street"
                                    minLength={2}
                                    title={t("taxDataInvoicingView.street")}
                                    value={props.street || ""}
                                    onChange={props.onChange}
                                    validator={props.validator.streetValidator}
                                  />
                                  {props.errorStreet && (
                                    <span className="hint-message-error">
                                      {t(
                                        "taxDataInvoincingValidator.errorStreet"
                                      )}
                                    </span>
                                  )}
                                </div>
                                <div className="input-style-taxData">
                                  <InputsFormPure
                                    type="text"
                                    name="colony"
                                    minLength={2}
                                    title={t("taxDataInvoicingView.colony")}
                                    value={props.colony || ""}
                                    onChange={props.onChange}
                                    validator={props.validator.colonyValidator}
                                  />
                                  {props.errorColony && (
                                    <span className="hint-message-error">
                                      {t(
                                        "taxDataInvoincingValidator.errorColony"
                                      )}
                                    </span>
                                  )}
                                </div>
                              </Grid>
                              <Grid item lg={6} md={6} sm={12} xs={12}>
                                <div className="input-style-taxData">
                                  <InputsFormPure
                                    type="text"
                                    name="township"
                                    minLength={2}
                                    title={t("taxDataInvoicingView.township")}
                                    value={props.township || ""}
                                    onChange={props.onChange}
                                    validator={
                                      props.validator.townshipValidator
                                    }
                                  />
                                  {props.errorTownship && (
                                    <span className="hint-message-error">
                                      {t(
                                        "taxDataInvoincingValidator.errorTownship"
                                      )}
                                    </span>
                                  )}
                                </div>
                                <div className="input-style-taxData">
                                  <InputsFormPure
                                    type="text"
                                    name="state"
                                    minLength={2}
                                    title={t("taxDataInvoicingView.state")}
                                    value={props.state || ""}
                                    onChange={props.onChange}
                                    validator={props.validator.stateValidator}
                                  />
                                  {props.errorState && (
                                    <span className="hint-message-error">
                                      {t(
                                        "taxDataInvoincingValidator.errorState"
                                      )}
                                    </span>
                                  )}
                                </div>
                                <div className="input-style-taxData">
                                  <InputsFormPure
                                    type="text"
                                    name="zipCode"
                                    minLength={2}
                                    title={t("taxDaticingView.zipCode")}
                                    value={props.zipCode || ""}
                                    onChange={props.onChange}
                                    validator={props.validator.zipCodeValidator}
                                  />
                                  {props.errorZipCode && (
                                    <span className="hint-message-error">
                                      {t(
                                        "taxDataInvoincingValidator.errorZipCode"
                                      )}
                                    </span>
                                  )}
                                </div>
                                <div className="combo-invoiceUse">
                                  <ComboBoxTemplatePure
                                    title={t(
                                      "taxDataInvoicingView.invoiceUsage"
                                    )}
                                    data={props.invoiceUseOptions}
                                    // value={props.invoiceUseOptions || ''}
                                    textField="invoiceUse.name"
                                    dataItemKey="id"
                                    onChange={props.onChangeComboBoxInvoiceUse}
                                    placeholder={t(
                                      "taxDataInvoicingView.optionUse"
                                    )}
                                  />
                                </div>
                              </Grid>
                              <Grid
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                es={12}
                                className="checkbox-gpo-taxData"
                              >
                                <CheckBoxTemplatePure
                                  label={t(
                                    "taxDataInvoicingView.physicalPerson"
                                  )}
                                  // id={"personTypeId"}
                                  name="physicalPerson"
                                  value={props.personTypeId}
                                  checked={props.physicalPerson}
                                  onChange={props.onSelectPhysicalPerson}
                                  placeHolder
                                />
                                <CheckBoxTemplatePure
                                  label={t("taxDataInvoicingView.moralPerson")}
                                  // id={"personTypeId"}
                                  name="moralPerson"
                                  value={props.personTypeId}
                                  checked={props.moralPerson}
                                  onChange={props.onSelectMoralPerson}
                                  placeHolder
                                />
                              </Grid>
                              {props.errorCheckBox && (
                                <span className="hint-message-error">
                                  {t(
                                    "taxDataInvoincingValidator.personTypeCheckBox"
                                  )}
                                </span>
                              )}

                              <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                es={4}
                                className="txt-card-invoiceUsage"
                              >
                                <Grid
                                  lg={5}
                                  md={5}
                                  sm={5}
                                  xs={5}
                                  es={4}
                                  className="item-txt-invoiceUsage"
                                >
                                  <span className="text-invoiceUsage">
                                    {t(
                                      "taxDataInvoicingView.descriptionInvoiceUsage"
                                    )}
                                  </span>
                                  <span className="detail-values-first">
                                    {t("taxDataInvoicingView.descriptionPlan")}{" "}
                                    {props.descriptionPlan}{" "}
                                    {t("taxDataInvoicingView.credits")}
                                  </span>
                                  <span className="text-invoiceUsage">
                                    {t("taxDataInvoicingView.subtotal")}
                                  </span>
                                  <span className="price-invoiceUsage detail-values-first">
                                    {props.subtotal}
                                  </span>
                                </Grid>
                                <Grid
                                  lg={4}
                                  md={4}
                                  sm={4}
                                  xs={4}
                                  es={3}
                                  className="item-txt-invoiceUsage-center"
                                >
                                  <span className="text-invoiceUsage">
                                    {t("taxDataInvoicingView.paymentMethod")}
                                  </span>
                                  {props.paymentMethod === 1 && (
                                    <span className="detail-values-center">
                                      {" "}
                                      {t("taxDataInvoicingView.card")}
                                    </span>
                                  )}
                                  {props.paymentMethod === 2 && (
                                    <span className="detail-values-center">
                                      {" "}
                                      {t("taxDataInvoicingView.transfer")}
                                    </span>
                                  )}
                                  {props.paymentMethod === 3 && (
                                    <span className="detail-values-center">
                                      {" "}
                                      {t("planProcessView.a3TratoDirecto")}
                                    </span>
                                  )}
                                  <span className="text-invoiceUsage">
                                    {t("taxDataInvoicingView.iva")}
                                  </span>
                                  <span className="price-invoiceUsage detail-values-center">
                                    {props.iva}
                                  </span>
                                </Grid>
                                <Grid
                                  lg={3}
                                  md={3}
                                  sm={3}
                                  xs={3}
                                  es={3}
                                  className="item-txt-invoiceUsage-end"
                                >
                                  <span className="text-invoiceUsage">
                                    {t("taxDataInvoicingView.destinationMail")}
                                  </span>
                                  <span className="detail-values-end">
                                    {props.email}
                                  </span>
                                  <span className="text-invoiceUsage">
                                    {t("taxDataInvoicingView.total")}
                                  </span>
                                  <span className="price-invoiceUsage detail-values-end">
                                    {props.total}
                                  </span>
                                </Grid>
                              </Grid>
                            </Grid>
                          </fieldset>
                          <Grid
                            item
                            xs={12}
                            lg={12}
                            md={12}
                            sm={12}
                            es={12}
                            className="btns-taxData"
                          >
                            <Link to="/configuration-contracts-history">
                              <button
                                onClick={props.scrollWindow}
                                className="btn-style-taxData"
                              >
                                {t("taxDataInvoicingView.buttonBack")}
                              </button>
                            </Link>
                            <button
                              type={"submit"}
                              // onClick={props.scrollWindow}
                              onClick={(e) => {
                                props.onSubmitUpdateUserTaxData(e);
                              }}
                              className="taxDataInvoicing-submit"
                            >
                              {t("taxDataInvoicingView.invoicingDates")}
                            </button>
                          </Grid>
                        </Container>
                      </div>
                    </FormElement>
                  )}
                />
              </Grid>

              <Grid item xs={12} lg={12} md={12} sm={12} es={12}>
                <PromotionalFooterPure />
              </Grid>
            </Grid>
          </Container>
        </Container>
      )}

      {/* Alerts of Notification Completed and Loading */}
      <NotificationDialogsPure
        {...props}
        toggleLoadingRequesting={props.toggleLoadingRequesting}
        toggleCompletedRequesting={props.toggleCompletedRequesting}
        toggleErrorRequesting={props.toggleErrorRequesting}
      />
    </div>
  );
};

export { TaxDataInvoicingView as default };
